/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Pay_Advance_TooltipInputs */

const es_admin_billing_batch_pay_advance_tooltip = /** @type {(inputs: Admin_Billing_Batch_Pay_Advance_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar por adelantado`)
};

const en_admin_billing_batch_pay_advance_tooltip = /** @type {(inputs: Admin_Billing_Batch_Pay_Advance_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay in advance`)
};

/**
* | output |
* | --- |
* | "Pay in advance" |
*
* @param {Admin_Billing_Batch_Pay_Advance_TooltipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_pay_advance_tooltip = /** @type {((inputs?: Admin_Billing_Batch_Pay_Advance_TooltipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Pay_Advance_TooltipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_pay_advance_tooltip(inputs)
	return en_admin_billing_batch_pay_advance_tooltip(inputs)
});
export { admin_billing_batch_pay_advance_tooltip as "admin.billing.batch.pay_advance_tooltip" }